module.exports = __webpack_public_path__ + "static/img/b.bcc1a651.svg";